/* eslint-disable no-undef */
import React from 'react';
import { Styles } from './styles';
import { useMediaQuery, useTheme } from '@mui/material';
import { IPropertyPhoto } from '@stores/Property/types';

interface ImageGalleryProps {
  images: IPropertyPhoto[];
  selectedImageIndex: number;
  onImageSelect: (index: number, image: string) => void;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({
  images,
  onImageSelect,
  selectedImageIndex
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleImageClick = (image: string, index: number) => {
    onImageSelect(index, image);
  };

  return (
    <Styles.GalleryContainer>
      <Styles.GalleryGrid>
        {images.map((image, index) => (
          <Styles.ImageContainer
            key={index}
            style={{
              border:
                selectedImageIndex === index
                  ? '3px solid #04682E'
                  : '1px solid #e0e0e0',
              transform: selectedImageIndex === index ? 'scale(1.05)' : 'none'
            }}
            onClick={() => handleImageClick(image.uri, index)}
            aria-label={`Visualizar imagem ${index + 1}`}>
            <Styles.Image
              src={image.uri}
              alt={image.legenda || `Imagem ${index + 1} do imóvel`}
              loading="lazy"
            />
            {isMobile && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '5px',
                  right: '5px',
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  color: 'white',
                  borderRadius: '4px',
                  padding: '2px 6px',
                  fontSize: '12px'
                }}>
                {index + 1}/{images.length}
              </div>
            )}
          </Styles.ImageContainer>
        ))}
      </Styles.GalleryGrid>
    </Styles.GalleryContainer>
  );
};

export default ImageGallery;
